import * as ACTION from '../constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function* () {
	yield takeLatest(ACTION.UPDATE_WAREHOUSE.REQUEST, saga.updateWarehouse);
	yield takeLatest(ACTION.UPDATE_WAREHOUSE.SUCCESS, saga.updateWarehouseSuccess);
}
